const LevelColorEnum = {
  Level0: {
    value: 0,
    css: ''
  },
  Level1: {
    value: 1,
    css: 'E3F4FF'
  },
  Level2: {
    value: 2,
    css: 'light_purple'
  },
  Level3: {
    value: 3,
    css: 'lemon'
  },
  Level4: {
    value: 4,
    css: 'red lighten-5'
  },
  Level5: {
    value: 5,
    css: ''
  }
};

export default LevelColorEnum;



// WEBPACK FOOTER //
// ./src/constants/review/level_color.js